import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=4b722dec&scoped=true"
import script from "./TagItem.vue?vue&type=script&lang=js"
export * from "./TagItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b722dec",
  null
  
)

export default component.exports